import { chooseGame } from "../../ducks/lobby";
import { getModeId } from "../../util/util";

export function saveAndChooseGame(time, inc, variant) {
  const modeId = getModeId(time, variant);

  try {
    localStorage.setItem("chosenTime", time.toString());
    localStorage.setItem("chosenInc", inc.toString());
    localStorage.setItem("chosenVariant", variant.toString());
  } catch (e) {
    console.log(e);
  }
  chooseGame({ time, inc, variant, modeId });
}
